import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { bimWorkOrderPriceMTRDistributionGql } from '../../bimWorkOrderQueries';

const requestId = 'bimWorkOrderPriceMTRDistribution';

export const useBimWorkOrderPriceMTRDistribution = (workOrderPriceId: number) => {
    const [bimWorkOrderPriceMTRDistributionReset] = useResetStoreData({ requestId });

    const variables = useMemo(
        () => ({
            workOrderPriceId,
        }),
        [workOrderPriceId],
    );

    const [
        bimWorkOrderPriceMTRDistributionData,
        bimWorkOrderPriceMTRDistributionStatus,
        bimWorkOrderPriceMTRDistributionError,
        bimWorkOrderPriceMTRDistributionRequest,
    ] = useRequest({
        requestId,
        query: bimWorkOrderPriceMTRDistributionGql,
        withEffect: Boolean(workOrderPriceId),
        variables,
    });

    useEffect(() => {
        bimWorkOrderPriceMTRDistributionReset(undefined);
    }, [bimWorkOrderPriceMTRDistributionReset]);

    return {
        bimWorkOrderPriceMTRDistributionData,
        bimWorkOrderPriceMTRDistributionStatus,
        bimWorkOrderPriceMTRDistributionError,
        bimWorkOrderPriceMTRDistributionRequest,
        bimWorkOrderPriceMTRDistributionReset,
    };
};
